const config = {
    eosContentUrl: "/services/content/eos-content.js"
};

export default config;
